import { Typography } from "@packages/ds";
import styled from "styled-components";

import Button from "ds/Button";
import InputDefault from "ds/Input";

const IndentedBodyText = styled(Typography.BodyText)<{ left?: string }>`
  margin: auto 0;
  padding-left: ${({ left }) => left ?? `16px`};
`;

export const NoFieldText = styled(IndentedBodyText)`
  color: var(--mode-text-neutral-weakest-disabled);
  padding-top: 8px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: start;
`;

export const PlaceholderText = styled(Typography.BodyText)`
  color: var(--mode-text-neutral-weakest-disabled);
`;

export const MobileLabel = styled(Typography.Label)`
  display: none;

  @media (max-width: 720px) {
    display: block;
    margin-bottom: 8px;
  }
`;

export const SelectWrapper = styled.div`
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: max-content max-content;
  margin-bottom: auto;

  & button:last-of-type {
    padding-top: 16px;
  }
`;

export const ResourceRow = styled.div<{ autoscalingEnabled?: boolean }>`
  display: grid;
  column-gap: 8px;
  align-items: center;
  grid-template-columns: ${({ autoscalingEnabled }) => {
    const columns = ["209fr", "235fr", "111fr", "111fr"];
    if (autoscalingEnabled) {
      columns.push("111fr");
    }
    return columns.join(" ");
  }};

  @media (max-width: 930px) {
    grid-template-columns: ${({ autoscalingEnabled }) => {
      const columns = ["185fr", "185fr", "111fr", "111fr"];
      if (autoscalingEnabled) {
        columns.push("111fr");
      }
      return columns.join(" ");
    }};
  }
  @media (max-width: 810px) {
    grid-template-columns: 117fr 185fr 111fr 111fr 111fr;
  }
  @media (max-width: 720px) {
    display: flex;
    flex-wrap: wrap;
    row-gap: 8px;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: repeat(4, max-content);
    & > :nth-child(1) {
      width: 100%;
    }
    & > :nth-child(2) {
      width: calc(100% - 46px);
    }
    & > :nth-child(3) {
      width: calc(50% - 45px);
    }
    & > :nth-child(4) {
      width: calc(50% - 45px);
    }
  }
`;

export const ImageAndTitleWrapper = styled.div<{ indent?: boolean }>`
  display: grid;
  align-items: center;
  grid-template-columns: max-content 1fr;
  gap: 18px;
  ${({ indent }) => indent && `padding-left: 32px;`}

  @media (max-width: 720px) {
    padding-left: unset;
  }
`;

export const InputWrapper = styled.div`
  position: relative;
  margin-bottom: auto;
`;

export const DiskWrapper = styled.div`
  margin-bottom: auto;
  position: relative;
`;

export const Blank = styled(Typography.BodyText)<{
  gapSpace: number;
  disabled: boolean;
}>`
  position: absolute;
  left: ${({ gapSpace }) => `${gapSpace + 22}px`};
  top: 8px;
  display: block;
  z-index: 5;
  ${({ disabled }) =>
    disabled && `color: var(--input-granite-color,var(--granite));`}

  @media (max-width: 720px) {
    top: 32px;
  }
`;

export const Input = styled(InputDefault)`
  & > input {
    height: 40px;
  }
`;

export const AutoscalingBtn = styled(Button)`
  justify-content: flex-start;
  margin-left: 16px;

  &:hover::after {
    display: none;
  }
`;

export const ErrorText = styled(Typography.BodyText).attrs(() => ({
  size: "small"
}))`
  display: block;
  margin-top: 4px;
  color: var(--mode-text-critical-default);
`;
